import { makeStyles } from '@mui/styles';
import styled from 'styled-components';

export const MapComponentStyle = styled.div`
  height: ${props => props.mapHeight};
`;

export const MapStyle = styled.div`
  margin-bottom: 5px;
  z-index: 0;
  height: ${props => props.leafletMapHeight};
`;

export const useStyles = makeStyles(() => ({
  '@global': {
    '.MuiTreeItem-root.Mui-selected > .MuiTreeItem-content .MuiTreeItem-label:hover, .MuiTreeItem-root.Mui-selected:focus > .MuiTreeItem-content .MuiTreeItem-label': {
      backgroundColor: 'gray'
    }
  },
  alca: {
    padding: '0px',
    textAlign: 'center',
    // background: 'linear-gradient(45deg, #4a5fe2 30%, #71dcff 90%)',
    // boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
    background: 'trasparent ',
    boxShadow: 'none',
    // borderWidth: 3,
    // borderStyle: "groove",
    // borderRadius: 3,
    color: 'white'
  },
  alcaPlus: {
    padding: '0px',
    textAlign: 'center',
    background: 'trasparent ',
    boxShadow: 'none',
    color: 'white',
    zIndex: 25
  },
  azulIpsilumButton: {
    color: ' #2A3F90',
    borderColor: '#2A3F90'
  },
  azulIpsilumBackground: {
    color: 'white',
    backgroundColor: '#2A3F90',
    borderColor: '#2A3F90'
  },
  azulIpsilum: {
    color: ' #2A3F90'
  },
  bagrouV: {
    backgroundColor: 'transparent',
    boxShadow: 'none'
    // background: 'linear-gradient(90deg, #00e676 40%, transparent 1%) 20px 0, #fff',
    // backgroundSize: '50px 10px'
  },
  bagrouH: {
    backgroundColor: 'transparent',
    boxShadow: 'none'
    // background: 'linear-gradient(0deg, #00e676 30%, transparent 1%) 20px 0, #fff',
    // backgroundSize: '50px 10px'
  },
  bagrouR: {
    backgroundColor: 'transparent',
    boxShadow: 'none'
    // background: 'linear-gradient(0deg, #f50057 30%, transparent 1%) 20px 0, #fff',
    // backgroundSize: '50px 30px'
  },
  boxTree: {
    flexGrow: 1,
    maxHeight: '45%',
    height: '45%',
    overflow: 'auto',
    background: 'white',
    // background: '#f5d176',
    border: 0,
    borderRadius: 3,
    zIndex: '100',
    color: 'Black'
  },
  elco: {
    padding: '0px',
    textAlign: 'center',
    // background: 'rgba(93,138,168,0.0)',
    borderWidth: 2,
    borderRadius: 3,
    position: 'relative',
    zIndex: '100',
    color: 'white'
  },
  elcobutton: {
    padding: '0px',
    textAlign: 'center',
    background: 'transparent',
    position: 'relative',
    width: '100%',
    height: '100%',
    zIndex: '100',
    color: 'white'
  },
  elcoPlus: {
    flexGrow: 1,
    overflow: 'auto',
    background: '#fff',
    border: 0,
    borderRadius: 3,
    zIndex: '100',
    color: 'Black'
    // height: 48,
  },
  icon: {
    fontSize: 20
  },
  iconButtonStyle: {
    color: '#2A3F90'
    // size: 'small'
  },
  iconButtonCircle: {
    border: '1px solid',
    borderColor: '#2A3F90',
    color: '#2A3F90',
    size: 'small'
  },
  labelRoot: {
    display: 'flex',
    alignItems: 'center'
  },
  label: {
    backgroundColor: 'trasparent',
    color: 'Black'
  },
  margenes: {
    // paddingLeft: '16px',
    // paddingRight: '16px',
    width: '100%'
  },
  margin: {
    margin: '8px'
  },
  modalBasic: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 700,
    height: 425,
    backgroundColor: 'white',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4
  },
  modalPaper: {
    position: 'absolute',
    width: 400,
    backgroundColor: 'white',
    border: '2px solid #000',
    padding: '24px'
  },
  modalPaperAuto: {
    position: 'relative',
    width: 'auto',
    backgroundColor: 'white',
    border: '2px solid #000',
    padding: '24px',
    overflowX: 'scroll'
  },
  modalPaperAux: {
    position: 'relative',
    width: 'auto',
    backgroundColor: 'white',
    border: '2px solid #000'
  },
  navbarStyle: {
    backgroundColor: 'rgba(33, 33, 33, .5)',
    color: 'white',
    height: '100%',
    justifyContent: 'center',
    overflow: 'hidden'
  },
  paper: {
    padding: '0px',
    textAlign: 'left',
    background: 'transparent',
    position: 'relative',
    zIndex: '50',
    borderRadius: 3,
    overflow: 'hidden'
  },
  resi: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '80%',
    height: '80%',
    borderRadius: 3,
    borderColor: 'blue',
    zIndex: '50'
  },
  residiv: {
    width: '100%',
    height: '100%'
  },
  root: {
    flexGrow: 1
  },
  rootplus: {
    flexGrow: 1,
    height: '100%'
  },
  rootTree: {
    flexGrow: 1,
    fontSize: 36
  },
  textField: {
    width: '22ch'
  },
  toggleButton: {
    position: 'absolute',
    top: '30px',
    right: '30px',
    backgroundColor: 'gray',
    // zIndex: "99999",

    '&.MuiIconButton-root:hover': {
      backgroundColor: 'black'
    }
  },
  withoutLabel: {
    marginTop: '40px'
  }
}));
